<template>
  <v-flex xs12 lg6>
    <v-menu
      :close-on-content-click="true"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
    >
      <v-text-field
      slot="activator"
      v-model="dateFormatted"
      label="Data inicial"
      :hint="`Padrão: ${model}`"
      persistent-hint
      prepend-icon="event"
      ></v-text-field>
      <v-date-picker v-model="initialDate" no-title @input="updateInitialDate"></v-date-picker>
    </v-menu>
  </v-flex>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'InitialDate',
  computed: {
    dateFormatted() {
      return moment(this.initialDate).format('DD/MM/YYYY');
    },
    initialDate: {
      get() {
        return this.model;
      },
      set(newDate) {
        this.updateInitialDate(newDate);
        this.model;
      },
    },
    ...mapGetters({
      model: 'deposits/initialDate',
    }),
  },
  methods: {
    ...mapActions({
      updateInitialDate: 'deposits/updateInitialDate',
    }),
  },
};
</script>
